export default "__VITE_ASSET__YsOhX9i3__"